import Vue from 'vue';
export default Vue.extend({
    props: {
        item: {
            type: Object,
            default: null,
        },
        index: {
            type: Number,
            default: 0,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isLink() {
            var _a;
            return !!((_a = this.item) === null || _a === void 0 ? void 0 : _a.to);
        },
        text() {
            var _a;
            return (_a = this.item) === null || _a === void 0 ? void 0 : _a.text;
        },
        tabComponent() {
            return this.isLink ? 'router-link' : 'button';
        },
        activeClass() {
            return 'border-blue-600 text-blue-600';
        },
        inactiveClass() {
            return 'border-transparent text-gray-70 hover:border-blue-600 hover:text-blue-600';
        },
        linkProps() {
            return this.isLink
                ? { exact: true, activeClass: this.isActive ? '' : this.activeClass }
                : {};
        },
    },
    methods: {
        onClick() {
            this.$emit('selected', this.index);
        },
    },
});
